var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AthleteField',{attrs:{"label":_vm.label}},[_c('p',{staticClass:"m-0 mb-1 font-medium text-gray-900",class:{'ds-text-base': !_vm.primary, 'ds-text-xl lg:ds-text-2xl': _vm.primary},domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }